import i18next from 'i18next';
export function i18n(locale) {
    void i18next
        .use({
        type: 'backend',
        read: function (language, _namespace, callback) {
            // We configure how i18next should fetch a translation resource when it
            // needs it: We use Webpack's dynamic imports to fetch resources without
            // increasing our bundle size.
            //
            // See https://webpack.js.org/guides/code-splitting/#dynamic-imports for
            // more information.
            return import(
            /* webpackChunkName: "[request]" */ "./assets/locales/PasswordInput_".concat(language, ".json"))
                .then(function (translation) {
                return callback(null, translation);
            })
                .catch(function (error) { return callback(error); });
        },
    })
        .init({
        // Initial language
        lng: locale,
        // Fallback language
        fallbackLng: 'en',
        // Don't use a key separator (no support for nested translation objects)
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            prefix: '{',
            suffix: '}',
        },
        // Wait for translation data to be available before rendering a component
        react: {
            wait: true,
        },
    });
    return i18next;
}
//# sourceMappingURL=i18n.js.map